module.exports = __webpack_public_path__ + "static/media/mango.e6a8642a.svg";